import axios from "axios";
import { cleanObject } from "helper/cleanObject";

const path = "/collections/";

export const collectionService = {
  async list(filter = {}) {
    let searchParams = new URLSearchParams(cleanObject(filter));
    return await axios.get(path + "?" + searchParams.toString());
  },

  async view(id) {
    return await axios.get(path + id);
  },

  async update(id, payload) {
    return await axios.patch(path + id, payload);
  },

  async updatePaymentOptions(id, payload) {
    return await axios.patch(path + `${id}/payment-options/`, payload);
  },

  async create(payload) {
    return await axios.post(path, payload);
  },
  async remove(id) {
    return await axios.delete(path + id);
  },

  async refreshAllMetadata(address) {
    return await axios.get(path + "refresh-metadata-nfts/" + address);
  },

  async getByAddress(address) {
    return await axios.get(path + "getByAddress/" + address);
  },

  async exportRank(address) {
    return await axios.post(`/attributes/export/${address}`);
  },
};
